// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-co-sell-opportunity-title {
  background-color: #F7FAFC;
  font-size: 14px;
  font-weight: bold;
  color: #142B31;
  display: flex;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #D3E1ED;
}

.section-fields-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 32px;
}

.section-fields-2col > div {
  margin-bottom: 12px;
}

@media (max-width: 700px) {
  .section-fields-2col {
    grid-template-columns: 1fr;
  }
}
.sync-status-container {
  padding: 12px;
  background-color: #f3f3f3;
  border-radius: 6px;
  border: 1px solid #d8dde6;
}

.sync-info-row {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.info-label {
  font-weight: bold;
  color: #3e3e3c;
  min-width: 140px;
  margin-right: 12px;
}

.info-value {
  color: #3e3e3c;
  flex: 1 1;
}

.success-status {
  color: #2e844a;
  font-weight: bold;
  background-color: #d4f3d0;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.failed-status {
  color: #c23934;
  font-weight: bold;
  background-color: #fedad8;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.error-details-section {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #d8dde6;
}

.error-details-title {
  font-weight: bold;
  color: #3e3e3c;
  margin-bottom: 8px;
}

.error-table {
  background-color: white;
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

.error-table th, .error-table td {
  border: 1px solid #d8dde6;
  padding: 6px 10px;
  text-align: left;
}

.error-code {
  font-family: "Courier New", monospace;
  font-size: 0.9em;
  color: #c23934;
  font-weight: 500;
}

.error-field {
  font-family: "Courier New", monospace;
  font-size: 0.9em;
  color: #0070d2;
}

.error-message {
  color: #3e3e3c;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/pages/CoSellOpportunities/ViewCoSellOpportunity/ViewCoSellOpportunity.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AACD;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAGA;EACE;IACE,0BAAA;EAAF;AACF;AAGA;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,SAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,iBAAA;EACA,6BAAA;AADJ;;AAIA;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;AADJ;;AAIA;EACI,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AADJ;;AAGA;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,qCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,qCAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAAJ","sourcesContent":[".view-co-sell-opportunity-title {\n\tbackground-color: #F7FAFC;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: #142B31;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 20px 30px;\n\tborder-bottom: 1px solid #D3E1ED;\n}\n\n.section-fields-2col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 32px;\n}\n\n.section-fields-2col > div {\n  margin-bottom: 12px;\n}\n\n// Responsive: 1 column on mobile\n@media (max-width: 700px) {\n  .section-fields-2col {\n    grid-template-columns: 1fr;\n  }\n} \n\n.sync-status-container {\n    padding: 12px;\n    background-color: #f3f3f3;\n    border-radius: 6px;\n    border: 1px solid #d8dde6;\n}\n\n.sync-info-row {\n    display: flex;\n    margin-bottom: 8px;\n    align-items: flex-start;\n}\n\n.info-label {\n    font-weight: bold;\n    color: #3e3e3c;\n    min-width: 140px;\n    margin-right: 12px;\n}\n\n.info-value {\n    color: #3e3e3c;\n    flex: 1;\n}\n\n.success-status {\n    color: #2e844a;\n    font-weight: bold;\n    background-color: #d4f3d0;\n    padding: 4px 8px;\n    border-radius: 4px;\n    display: inline-block;\n}\n\n.failed-status {\n    color: #c23934;\n    font-weight: bold;\n    background-color: #fedad8;\n    padding: 4px 8px;\n    border-radius: 4px;\n    display: inline-block;\n} \n\n.error-details-section {\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid #d8dde6;\n}\n\n.error-details-title {\n    font-weight: bold;\n    color: #3e3e3c;\n    margin-bottom: 8px;\n}\n\n.error-table {\n    background-color: white;\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 8px;\n}\n.error-table th, .error-table td {\n    border: 1px solid #d8dde6;\n    padding: 6px 10px;\n    text-align: left;\n}\n\n.error-code {\n    font-family: 'Courier New', monospace;\n    font-size: 0.9em;\n    color: #c23934;\n    font-weight: 500;\n}\n\n.error-field {\n    font-family: 'Courier New', monospace;\n    font-size: 0.9em;\n    color: #0070d2;\n}\n\n.error-message {\n    color: #3e3e3c;\n    line-height: 1.4;\n    white-space: normal;\n    word-break: break-word;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
